export const referralCode = 'YL188';

export const rebateExchanges = [
  {
    id: 'binance',
    name: '币安 Binance',
    shortName: '币安',
    badge: '全球最大',
    rebate: '20%',
    accent: '#d4a843',
    logo: '/images/exchanges/binance-logo.svg',
    summary: '全球交易量第一，交易对丰富，适合把主要交易账户放在这里。',
    detailSummary: '全球最大，流动性最强。邀请码 YL188，注册币安永久享受 20% 手续费返佣，每笔交易自动返还。',
    tags: ['SAFU 基金', '90 天召回', 'BNB 折扣'],
    registerUrl: 'https://www.bsmkweb.cc/register?ref=YL188',
    directCta: '直接注册币安',
    strengths: [
      ['全球交易量第一', '任何时间、主流币种和热门新币都有足够流动性。'],
      ['10 亿美元 SAFU 保障', '平台安全基金用于极端情况下的资产保障。'],
      ['交易对覆盖广', '现货、合约、理财和 Web3 钱包都能在一个账户里完成。'],
    ],
    rebind: [
      ['官方补绑链接', '适合刚注册、还没有充值或交易记录的新用户。'],
      ['删号重新注册', '麻烦一些，但没有上级关系时可作为备选。'],
      ['老用户召回换绑', '注册超过 90 天且近期未交易的账户，可咨询客服确认资格。'],
    ],
    steps: [
      ['打开币安官网', '通过本页专属链接进入注册页面，邀请码 YL188 会自动带入。'],
      ['验证手机号或邮箱', '输入常用手机号或邮箱，接收验证码后完成校验。'],
      ['确认邀请码 YL188', '邀请码栏必须是 YL188，不填就无法拿到永久返佣。'],
      ['设置登录密码', '使用独立复杂密码，并开启双重验证。'],
      ['完成 KYC 实名认证', '上传身份证或护照并完成人脸识别，通过后即可交易和提现。'],
    ],
    benefits: [
      ['新用户交易费返还', '完成 KYC 后关注官方活动页，可叠加平台新用户任务。'],
      ['BNB 抵扣手续费', '开启 BNB 抵扣后可进一步降低现货手续费。'],
    ],
    faq: [
      ['YL188 返佣从哪来？', '来自平台对手续费的返还，不会从你的资产里额外扣费。'],
      ['返佣什么时候到账？', '通常按平台规则自动结算到交易账户，以后台展示为准。'],
    ],
  },
  {
    id: 'okx',
    name: 'OKX',
    shortName: 'OKX',
    badge: 'Web3 强项',
    rebate: '20%',
    accent: '#4da3ff',
    logo: '/images/exchanges/okx-logo.svg',
    summary: '现货 Maker 费率低，内置 Web3 钱包体验成熟，适合交易和链上工具一起用。',
    detailSummary: 'OKX 的 Web3 钱包、多链工具和交易所账户整合较好，适合经常做链上操作的用户。',
    tags: ['Maker 0.08%', '4 种换绑', 'OKB 折扣'],
    registerUrl: '#',
    directCta: '',
    strengths: [
      ['Web3 钱包成熟', '多链资产、DEX、跨链和 NFT 工具集中在同一个 App。'],
      ['现货 Maker 费率低', '适合经常挂单、做低成本现货交易的用户。'],
      ['产品线完整', '现货、合约、理财和链上入口覆盖完整。'],
    ],
    rebind: [
      ['无上级申请', '如果账户没有绑定上级，可尝试联系官方客服补绑。'],
      ['180 天闲置换绑', '长期未交易账户可咨询客服是否有召回资格。'],
      ['大额用户通道', '资金体量较大时可联系官方客服进一步核实。'],
    ],
    steps: [
      ['打开 OKX 注册页', '使用你的专属注册链接或在邀请码栏填写 YL188。'],
      ['完成邮箱或手机验证', '确认账号归属，避免后续安全风控。'],
      ['确认邀请码 YL188', '注册提交前再次检查推荐码。'],
      ['完成身份认证', '根据平台提示完成 KYC。'],
      ['开启交易前安全设置', '建议开启 2FA、资金密码和防钓鱼码。'],
    ],
    benefits: [
      ['Web3 钱包入口', '交易所与链上钱包可以配合使用。'],
      ['OKB 生态权益', '按平台规则享受代币相关权益。'],
    ],
    faq: [
      ['OKX 如何确认返佣关系？', '注册或换绑后，以账户后台和官方客服确认结果为准。'],
      ['OKX 能换绑吗？', '需看账号是否已有上级关系，以官方客服答复为准。'],
    ],
  },
  {
    id: 'bitget',
    name: 'Bitget',
    shortName: 'Bitget',
    badge: '跟单领先',
    rebate: '20%',
    accent: '#00b4d8',
    logo: '/images/exchanges/bitget-logo.svg',
    summary: '跟单系统行业领先，合约和现货覆盖完整，适合想参考策略的新用户。',
    detailSummary: 'Bitget 的跟单系统行业领先，适合想从策略跟随开始熟悉合约和风险控制的新用户。',
    tags: ['跟单交易', 'BGB 折扣', '合约深度'],
    registerUrl: 'https://partner.hdmune.cn/bg/9zp7231q',
    directCta: '直接注册 Bitget',
    strengths: [
      ['跟单系统行业领先', '可以观察交易员策略，但仍需要自己控制仓位和风险。'],
      ['合约体验完整', '适合以合约交易、跟单和策略观察为主的用户。'],
      ['BGB 生态折扣', '平台代币权益可辅助降低部分交易成本。'],
    ],
    rebind: [
      ['新账号注册', '注册时直接使用专属链接，返佣关系更清晰。'],
      ['检查返佣关系', '注册后在账户或客服处确认是否绑定成功。'],
      ['绑定 UID 核对', '把 UID 保存好，便于后续人工核对返佣关系。'],
    ],
    steps: [
      ['打开 Bitget 专属链接', '通过本页按钮进入，链接会携带返佣关系。'],
      ['注册并验证账号', '使用手机号或邮箱完成基础验证。'],
      ['确认邀请码 YL188', '如果页面要求手动输入，填写 YL188。'],
      ['完成 KYC', '按平台提示上传证件并完成身份认证。'],
      ['保存 UID 并开始交易', '保存 UID，后续核对返佣或客服沟通会用到。'],
    ],
    benefits: [
      ['跟单专区', '适合观察不同交易员的风格和回撤。'],
      ['BGB 折扣', '按平台规则使用 BGB 可获得部分手续费优惠。'],
    ],
    faq: [
      ['Bitget 适合新手吗？', '适合想研究跟单和合约的用户，建议先熟悉规则再逐步提高交易规模。'],
      ['返佣和跟单冲突吗？', '通常不冲突，具体以平台账户后台显示为准。'],
    ],
  },
];

export const getRebateExchange = (id) => rebateExchanges.find((exchange) => exchange.id === id);

export const feeRows = [
  ['现货 Maker', '0.10%', '0.08%', '0.10%'],
  ['现货 Taker', '0.10%', '0.10%', '0.10%'],
  ['合约 Maker', '0.02%', '0.02%', '0.02%'],
  ['合约 Taker', '0.05%', '0.05%', '0.06%'],
  ['YL188 返佣', '20%', '20%', '20%'],
  ['代币折扣', 'BNB -25%', 'OKB', 'BGB 折扣'],
  ['特色', '流动性最强', 'Web3 钱包', '跟单领先'],
];
